import React, { useState } from 'react';
import ReactSlider from 'react-slider';
interface IBar {
  curTime: number;
  played: number;
  loaded: number;
  duration: number;
  onTimeUpdate: (e: number) => void;
}
export default function Bar(props: IBar) {
  const { duration, curTime, played, loaded, onTimeUpdate } = props;

  //const curPercentage = (curTime / duration) * 100;
  const [curPercentage, setCurPercentage] = useState(0);
  function formatTime(time: number): string {
    if (time) {
      const min = Math.floor(time / 60);
      const sec = Math.floor(time % 60);
      return `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec}`;
    } else {
      return '00:00';
    }
  }

  React.useEffect(() => {
    setCurPercentage(Math.round(played * 100));
  }, [played]);

  function calcClickedTime(e: number) {
    return e * duration;
  }

  function handleTimeDrag(e: number) {
    setCurPercentage(e * 100);
    onTimeUpdate(calcClickedTime(e));
  }

  return (
    <div className=" flex flex-row ">
      <span className="mr-4  w-10 text-white">{formatTime(curTime)}</span>
      <div
        className="mt-2  flex-1 h-1 rounded-sm flex items-center "
        style={{
          background: `linear-gradient(to right,#F14E22 ${curPercentage}%,rgba(255, 255, 255, 0.7)  ${curPercentage}% ${Math.round(
            loaded * 100
          )}%,rgba(195, 206, 227, 0.5) 0)`,
        }}
      >
        <ReactSlider
          className="flex-1 h-1 rounded-sm flex items-center cursor-pointer"
          thumbClassName="cursor-pointer h-3 w-3 border-white rounded-lg  bg-red-500 "
          trackClassName="example-track"
          value={curPercentage}
          onChange={(value) => {
            handleTimeDrag(value / 100);
          }}
        />
      </div>
      <span className="ml-4 text-white">{formatTime(duration)}</span>
    </div>
  );
}
